import React from "react";
import Icon from "@ant-design/icons";

const NewProfileIconSVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none">
    <path
      d="M27 7.99998H21.9125C21.6719 6.60634 20.9466 5.3425 19.8649 4.43151C18.7831 3.52051 17.4143 3.02094 16 3.02094C14.5857 3.02094 13.2169 3.52051 12.1351 4.43151C11.0534 5.3425 10.3281 6.60634 10.0875 7.99998H5C4.46957 7.99998 3.96086 8.2107 3.58579 8.58577C3.21071 8.96084 3 9.46955 3 9.99998V26C3 26.5304 3.21071 27.0391 3.58579 27.4142C3.96086 27.7893 4.46957 28 5 28H27C27.5304 28 28.0391 27.7893 28.4142 27.4142C28.7893 27.0391 29 26.5304 29 26V9.99998C29 9.46955 28.7893 8.96084 28.4142 8.58577C28.0391 8.2107 27.5304 7.99998 27 7.99998V7.99998ZM16 4.99998C16.8866 5.00167 17.7476 5.29695 18.4487 5.8397C19.1497 6.38244 19.6513 7.14209 19.875 7.99998H12.125C12.3487 7.14209 12.8503 6.38244 13.5513 5.8397C14.2524 5.29695 15.1134 5.00167 16 4.99998V4.99998Z"
      fill="url(#paint0_linear_426_217)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_426_217"
        x1="16"
        y1="3.02094"
        x2="16"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#708AC2" />
        <stop offset="1" stop-color="#5673B2" />
      </linearGradient>
    </defs>
  </svg>
);

const NewProfileIcon = (props) => (
  <Icon component={NewProfileIconSVG} {...props} />
);

export default NewProfileIcon;
